import { Injectable, signal } from '@angular/core';
import { signOut } from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root',
})
export class AmplifyService {
  public signedIn(signedIn: boolean): void {
    this.isSignedInSignal.set(signedIn);
  }

  public signingOut(): void {
    signOut().then(() => {
      this.isSignedInSignal.set(false);
    });
  }

  private readonly isSignedInSignal = signal<boolean>(false);

  public isSignedIn = this.isSignedInSignal.asReadonly();
}
